import { Row, Switch } from "antd";

export default function ShowAllSwitch({ showChatView, setShowChatView }) {
  const onShowAllChange = (e) => {
    setShowChatView(e);
  };
  return (
      <Row justify={"space-between"} align={"middle"}>
        <div className="d-flex hs-fs-14 align-items-center">
          <div className="actionIconsSprite2 show-all-chat-history-icon" />
          Chat History
        </div>
        <Switch className="addPhoneSwitch mx-2" data-cy="show-all" value={showChatView} onChange={onShowAllChange} />
      </Row>
  );
}
